import gql from 'graphql-tag';
import { InstallableUserIntegrationSchema } from '../../definitions/schemas';
import Interface from '../Interface';

interface InstallableUserIntegrationsData {
  installableUserIntegrations: InstallableUserIntegrationSchema[];
}

export default class UserIntegrationsInterface extends Interface {
  public async installableUserIntegrations() {
    const response = await this.query<InstallableUserIntegrationsData>(
      () =>
        this.apolloService.executeQuery<InstallableUserIntegrationsData>({
          query: gql`
            query installableUserIntegrations {
              installableUserIntegrations {
                providerName
                integrationType
                installUrl
                connectionVariant
              }
            }
          `,
        }),
      'Error pulling user integrations'
    );
    return response.installableUserIntegrations;
  }

  public async disconnectUserCrm(id: string) {
    return this.mutate<null>(async () => {
      const response = await this.apolloService.executeMutation({
        mutation: gql`
          mutation disconnectUserCrm($input: DisconnectUserCrmInput!) {
            disconnectUserCrm(input: $input) {
              errors
            }
          }
        `,
        variables: {
          input: { id },
        },
      });

      const { errors } = response.data.disconnectUserCrm;

      return {
        data: null,
        serverErrors: errors,
        serverMessage: '',
      };
    }, 'Error disconnecting user CRM');
  }
}
